module.exports = __webpack_public_path__ + "img/logo-heppi@2x.fd9484ab.png";